import { deeplinkNavigation } from './DeeplinkNavigationParams'

export const navigateMonthlyReport = () => {
  deeplinkNavigation({ name: 'MonthlyReport' })
}
